import dayjs from "dayjs";
const constants = {
	//API environment constants
	ApiUrl: process.env.REACT_APP_API_COMMON_URL,
	AdminApiUrl: process.env.REACT_APP_API_ADMIN_URL,
	StudentApiUrl: process.env.REACT_APP_API_STUDENT_URL,
	BaseUrl: process.env.REACT_APP_URLS_FOR_BASE,
	EnviromentName: process.env.REACT_APP_ENV,
	SiteKey: process.env.REACT_APP_SITE_KEY,
	//Page constants should be entered here.
	Home: "Home",
	Login: "Login",
	Logout: "Logout",
	Register: "Register",
	BuyBook: "Buy Book",
	WelcomeBack: "Welcome back!",
	Username: "Username",
	Password: "Password",
	Help: "Help",
	Users: "Users",
	EmailAddress: "Email Address",
	EmailValidationMsg: "Enter valid email address",
	MyProfile: "My Profile",
	ContactUs: "Contact Us",
	Resources: "Resources",
	Feedback: "Feedback",
	Codes: "Codes",
	AdminUsers: "Admin Users",
	StudentUsers: "Student Users",
	Acknowledgements: "Acknowledgements",
	NoAccount: "Don't have an account?",
	CreateAccount: "Create an account now!",
	ForgotPassword:"Forgot Password?",
	ChangePassword:"Change Password",
	SomethingWentWrong:"Something went wrong. Please try again.",
	BackHome: "Back to Home",
	ShareTitleText:"Check this out!",
	Images:"Images",
	Videos:"Videos",
	Dashboard:"Dashboard",
	MonthlyRegistration:"Monthly registration",
	YearlyRegistration:"Yearly registration",
	TopTenStates:"Top 10 US States",
	TopTenCountries:"Top 10 Countries",
	RoleAnalysis:"Role Analysis",
	UniversityAnalysis:"University Analysis",
	UniversityAnalysisSub:"(Top 10 US Universities)",
	ShowMore:"Show More...",
	ShowLess: "Show Less...",
	//login
	InvalidLoginDetails: "Invalid login details",
	EnterPassword: "Enter Password",
	EnterUsername: "Enter Username",
	LogoutFailed: "Logout failed",

	//Forgot and Reset password
	ResetPassword: "Reset Password",
	PasswordChanged:"Password changed successfully. Click login to continue.",
	InvalidReset: "Invalid reset details.",
	NewPassword: "New Password",
	EnterNewPassword: "Enter New Password",
	ConfirmNewPassword: "Confirm New Password",
	RetypeNewPassword: "Re-type New Password",
	PasswordsDoNotMatch: "The two passwords that you entered do not match!",
	BackToLogin: "Back to Login",
	UsernameEmail: "Username/Email",
	EnterUserNameOrEmail: "Enter Username or Email",
	Submit: "Submit",
	Back: "Back",
	ConfirmPassword: "Confirm Password",
	SendInstruction: "Send Instructions",
	ForgotYourPassword: "Forgot your password? Don't Panic!",
	ForgotPasswordInstructions: "Enter either primary or alternate email address which you entered at the time of registration. Click Send Instructions button.",
	FPInstructionsSecond: "Then check your email Inbox (of either email account) for an email with further instructions. You will receive an email with a link to reset your password.",
	FPInstructionsThird: "If you do not find the email in your Inbox, check the Spam, Junk, or Promotions folders.",

	//Registration
	UsernameLengthValidation: "Username must be between 5 to 12 characters.",
	UsernameValidation: "Only letters (a-z), numbers (0-9), underscore (_) and dot (.) are allowed.",
	ErrorOccured: "An error occurred. Please try again.",
	OtherUniversityRegistration:"Enter University Name",
	EmailError: "An error occurred while validating emails",
	UsernameError: "An error occurred while validating username",
	PasswordTooltip: "Password length should be minimum 8 characters. It must contain at least 1 uppercase letter, 1 lowercase letter, a number, any special character and no spaces.",
	EnterConfirmPassword: "Enter Confirm Password",
	Email: "Email",
	EnterEmail: "Enter Email",
	EmailTooltip: "All communication from this website will be sent to this email address.",
	AlternateEmail: "Alternate Email",
	EnterAlternateEmail: "Enter Alternate Email",
	AltEmailTooltip: "Provide an alternate email address. If you do not receive any emails from this website, your alternate email address will be used to contact you.",
	FirstName: "First Name",
	EnterFirstName: "Enter First Name",
	FirstNameInvalid:"Invalid First Name",
	LastName: "Last Name",
	EnterLastName: "Enter Last Name",
	LastNameInvalid:"Invalid Last Name",
	Role: "Role",
	RoleMessage: "Please enter Role",
	IAm: "I am a:",
	Occupation: "Occupation",
	EnterOccupation: "Enter Occupation",
	Country: "Country",
	SelectCountry: "Select a Country",
	University: "University",
	UniversityRegistration:"Select university",
	UniversityName: "University Name",
	EnterNumber: "Enter Contact Number",
	Number: "1(999)123-4567",
	BookCode: "Book Code",
	EnterCode: "Enter Book Code",
	InvalidCode: "Invalid Book Code",
	Code: "XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
	TermsUse: "Accept Terms of Use",
	TermsAndCondition: "I have read and agree to the Terms of Use.",
	AccountAlready: "Already have an account?",
	OtherOccupationValid: "Enter any occupation not displayed in the Role dropdown.",
	OtherUniversityExists:"University name already exists. Enter a new one.",
	BookCodeTooltip: "The print version of the book will include the access code inside the front cover. The e-book will include a link and an access code. Your subscription to the online resources will be valid for 1 year only from the date of registration. Enter the access code exactly as given in the book including the dashes (e.g. 12345-ABCDE-67890-FGHIJ-54321).",
	BookCodeRule: "Your subscription to the online resources will be valid for 1 year only from the date of registration.",
	UsernameTooltip: "Username must be unique, a single word, having between 5 to 12 characters. It can contain only letters (a-z, A-Z), numbers (0-9),  underscore (_) and dot (.).",
	Previous: "Previous",
	Next: "Next",

	//Code Generation
	CodeGeneration: "Code Generation",
	ReqField: "This field is required.",
	Duration: "Duration (In months)",
	NoOfCodes: "No of codes",
	Type: "Type",
	SelectType: "Select Type",
	PaymentMode: "Payment Mode",
	Cancel: "Cancel",
	Generate: "Generate",
	//Listing
	Topic: "Topic",
	Aniamtion: "Animations",
	Definitions: 'Definitions',
	pageSize:20,
	Description: 'Description',
	//Profile
	Details: "Details",
	Close:"Close",
	Quit:"Quit",
	Save:"Save",
	Ok:"Ok",
	OR:"OR",
	//Messages
	SelectOptionOnly:"Select an option.",
	LoggedInAnotherBrowser:"You have been automatically logged out. It appears that you may be logged in another browser.",
	ClickHereTo:"Click here to",
	Profile: "My Profile",
	ValidTill: "Valid Till",
	ContactNumber: "Contact Number",
	//Activation
	Activation: "Account Activation",
	ActivationLinkGenerate:" to generate a new link for activation.",
	Here: "here",
	Click: "Click",
	ToLogin: " to Login.",
	//UsersList
	Admin: "Admin",
	Student: "Student",
	EditAdminUser: "Edit Admin User",
	EditStudentUser: "Edit Student User",
	Professional: "Professional",
	Faculty: "Faculty",
	Other: "Other",
	StartDate: "Start Date",
	Status: "Status",
	Active: "Active",
	NotActive: "Not Active",
	Pending: "Pending",
	Closed: "Closed",
	Cleared: "Cleared",
	Action: "Action",
	Name: "Name",
	State: "State",
	RegisteredOn: "Registered on",
	ValidUntil: "Valid until",
	Search: "Search",
	AdminUsersList: "Admin Users List",
	RegisteredStudents: "Registered Students",
	Showing: "Showing ",
	Of: " of ",
	Entries: " entries",
	FromTo: " to ",
	Reset: "Reset",
	//Feedback
	RequiredCourse: "Required for a course",
	Recommended: "Recommended for a course",
	ThroughFriend: "Through a friend/colleague",
	ASHA: "ASHA conference",
	Amazon: "Amazon",
	Internet: "Internet",
	SocialMedia: "Social media",
	StateConference: "State conference",
	SendFeedback: "SEND US FEEDBACK",
	EnterOther: "Enter other option",
	ChooseOption: "Choose the appropriate option",
	Question1: "How did you hear about the book?",
	Question2: "The tests were challenging",
	Question3: "Overall rating of the entire product (book and website)",
	Agree: "Agree",
	Undecided: "Undecided",
	Disagree: "Disagree",
	Excellent: "Excellent",
	VeryGood: "Very Good",
	Good: "Good",
	Fair: "Fair",
	Poor: "Poor",
	Comments: "Comments...",
	EnterComment: "Enter comment",
	Required: "Required",
	Recommend: "Recommended",
	Friend: "Friend",
	Socials: "Socials",
	ASHA1: "ASHA",
	Conference: "Conference",
	//Contact Us
	Subject: "Subject",
	Message: "Message",
	Send: "Send",
	FullNameCheck: "Enter name",
	PhoneCheck: "Enter phone number",
	SubjectCheck:"Enter email subject",
	EmailCheck: "Enter email",
	Date: "Date",
	From: "From",
	To: "To",
	Clear: "Clear",
	Viewed:"Viewed",
	DateFormat : "MM/DD/YYYY",
	DateFormat2 : "MM-DD-YYYY",
	Display: "Display",
	List: "List",
	TimeTaken: "Time Taken",
	DateFormat3: "YYYY-MM-DD",
	Chapter: "Chapter",
	Edit: "Edit",
	CodesErrMsg: "Failed to generate code",
	Copyright : "Copyright",
	//resend - activation
	ResendActivation: "Didn't receive the activation email?",
	ClickForResend: "Click here to resend it.",
	ResendActivationEmail: "Resend activation email",
	MessageActivationResend: "If you did not receive an email to activate your account, enter any one of the following details to receive an activation email again.",
	EmailValidationResend: "Not a valid Email!",
	Resendmail: "Resend Activation Email",
	ProedWebLink:"https://www.proedinc.com/",
	DateFormat4: "MMM D, YYYY",
	AllPrevYear:"All Previous Years",
	Animations:"Animations",
	BookPurchaseLink: "https://proedinc.com/products-14732.html",
	EBookPurchaseLink: "https://proedinc.com/products-14733.html",
	ShareSubText:"Dive into the latest research and treatment approaches with Introduction to Communicative Disorders, Fifth Edition.",
	WebsiteURL:"https://www.introtocommunicativedisorders.com/home",
	Title: "Title",
	FAQs: "FAQs",
	EditContent: "Edit Content",
	ContentName: "Content Name",
	Source: "Source",
	CompleteReCaptcha:"Complete ReCaptcha",
	ReCaptchaFailed:"ReCaptcha Failed",
	ICD: "ICD",
	CannotLoginAccount: "Why can't I login to my account?",
	AccessOnlineResources: "How do I access the online resources?",
	FindAccessCode: "How do I find the access code to register for the online resources?",
	UseMyCode: "Can someone else use my subscription?",
	DidNotReceiveMail: "I did not receive an email after registration. What do I do?",
	NotReceivingMails: "I am not receiving emails from this site.",
	ForgottenUsernamePassword: "What should I do if I have forgotten my username or password?",
	AccAccessInfo: "How long will I be able to access my account?",
	CannotAccessOnlineResources: "What should I do if I cannot access the online resources?",	
	EBook: "E-Book",
	Book: "Book",
	Paid: "Paid",
	Custom: "Custom",
	City: "City",
	LastUpdatedBy: "Last Updated By",
	LastUpdatedOn: "Last Updated On",
	UniversityMaster: "University Master",
	AddUniversity: "Add University",
	Universities: "Universities",
	SelectState: "Select State",
	TypeOfBook: "Type of Book",
	Free: "Free",
	//Video
	EditVideo: "Edit Video",
	CreatedOn: "Created on: ",
	UpdatedOn:" Updated on :",
	On: "on",
	UpdatedBy: "Updated by: ",
	VName: "Content Name",
	EditImage: "Edit Image",
	EditAnimation: "Edit Animation",
	Listing: "Listing",
	BookCodeList : "Book Code List",
	LastThreeMonthsLY: "Last 3 Months (Last Year)",
	ThisMonthLastYear: "This Month (Last Year)",
	LastThreeMonths: "Last 3 Months",
	LastMonth: "Last Month",
	ThisMonth: "This Month",
	LastYear: "Last Year",
	ThisYear: "This Year",
	PreviousYears: "Previous Years",
	FeedbackAnalysis: "Feedback Analysis",
	PositiveFeedback: "Positive Feedback: ",
	NegativeFeedback: "Negative Feedback: ",
	OtherFeedback: "Other Feedback: ",
	RegistrationsByStates: "Registrations by States (USA)",
	startDateOfTheYear : dayjs().startOf('year').format("YYYY-MM-DD"),
	endDateOfTheYear : dayjs().endOf('year').format("YYYY-MM-DD"),
	currentMonthSD: dayjs().startOf('month').format("YYYY-MM-DD"),
	currentMonthED: dayjs().endOf('month').format("YYYY-MM-DD"),
	lastMonthSD: dayjs().subtract(1, 'month').startOf('month').format("YYYY-MM-DD"), 
	lastMonthED: dayjs().subtract(1, 'month').endOf('month').format("YYYY-MM-DD"),
	lastThreeMonthED: dayjs().subtract(1, 'month').endOf('month').format("YYYY-MM-DD"), 
	lastThreeMonthSD: dayjs().subtract(3, 'month').startOf('month').format("YYYY-MM-DD"),
	currentMonthLastYearSD: dayjs().subtract(1, 'year').startOf('month').format("YYYY-MM-DD"), 
	currentMonthLastYearED: dayjs().subtract(1, 'year').endOf('month').format("YYYY-MM-DD"), 
	startDateOfTheLastYear : dayjs().subtract(1, 'year').startOf('year').format("YYYY-MM-DD"),
	endDateOfTheLastYear : dayjs().subtract(1, 'year').endOf('year').format("YYYY-MM-DD"),
	lastYearEndDate: dayjs().subtract(1, 'year').endOf('year').format("YYYY-MM-DD"),
	lastYearStartDate: dayjs("01/01/2017").format("YYYY-MM-DD"),
	lastthreemonthlastyearSD: dayjs().subtract(1, 'year').startOf('year').subtract(3, 'month').startOf('month').format("YYYY-MM-DD"),
	lastthreemonthlastyearED: dayjs().subtract(1, 'year').startOf('year').subtract(1, 'month').endOf('month').format("YYYY-MM-DD"),
	NoDataFound: "No Data Found",
	//Code listing
	Created: "Created",
	Registered: "Registered",
	Valid: "Valid",
	All: "All",
	Booktype: "Book type",
	//Documents
	Documents: "Documents",
	Document: "Document",
	ValidFrom: "Valid From",
	Updatedby: "Updated By",
	EndUsers: "EULA",
	Effectivefrom: "Effective From",
	PrivacyPolicyEducational: "Educational Products Privacy Policy",
	PrivacyPolicyHealth: "Health Care End User Privacy Policy",
	EndUserLicenseAgreement: "End User License Agreement",
	PROEDPrivacyPolicies: "PRO-ED Privacy Policies",
	Policies: "Policies",
	//Change docs
	ChangeDocMessage1:`PRO-ED, Inc. is updating its End User License Agreement ("Agreement" or "EULA") for this Product effective April 21, 2025.`,
	ChangeDocMessage2:`Our changes to this Agreement include:`,
	ChangeDocMessage3:`Some updates to our data deletion policies and that
													we will deactivate accounts that have been inactive
													in the last forty-eight (48) month period, We also
													added a warranty that our Products will NOT infringe
													U.S. copyrights and an indemnification for certain
													third party IP claims, and Updates to our limitation
													of liability.`,
	ChangeDocMessage4:`We recommend that you read the `,
	ChangeDocMessage6:`Thank you for being a PRO-ED Customer.`,
	ChangeDocMessage5:`to understand all the changes before this updated
													Agreement takes effect as you will be required to
													accept the Agreement before you can access the
													Product. If you have any questions, you can contact
													us at privacy@proedinc.com.`,
	EulaText: "I have read, agree with and understand the End User License Agreement.",
	PrivacyPolicyEducationalText: "I have read, agree with and understand the Educational Products Privacy Policy.",
	PrivacyPolicyHealthText: "I have read, agree with and understand the Health Care End User Privacy Policy.",
	Effective: "effective from",
	FileName: "File Name",
	//SETTINGS
	Settings: "Settings",
	LastLoginDate: "Last Login Date",
	Forgotpassword: "Forgot Password",
	Extend: "Extend",
	//CRONS
	Cron: "Crons",
	CronActivity: "Cron Activity",
	Registrations: "Registrations",
	Export:"Export",
	InvalidName: "Invalid name",
}
export default constants;
